import styled from '@emotion/styled';
import { DESKTOP_TOP_HEIGHT, MODIFIER_IS_OPEN } from '../../constants';

export const desktopList = 'desktop-list';
export const iconBtnClass = 'icon-btn';
export const desktopLinkClass = 'link-item';
export const verticalLine = 'vertical-line';
export const profileImageClass = 'profile-image';
export const desktopUserItemDropdownPopover = 'desktop-user-item-dropdown-popover';
export const contentWrapper = 'desktop-user-item-dropdown-content';
export const utilityInteractiveElement = 'utility-Interactive-element';
export const hoveredLink = 'hovered-link';
export const interactiveProfileElement = 'interactive-profile-element';
export const profileLink = 'profile-link';

export const StyledLi = styled.li`
  display: flex;
  align-items: center;
  height: ${DESKTOP_TOP_HEIGHT}px;
  .${desktopUserItemDropdownPopover} {
    padding: 12px 16px 12px 12px;
    position: absolute;
    min-width: 214px;
    right: 0;
    top: ${DESKTOP_TOP_HEIGHT}px;
    background: var(--podium-cds-color-bg-primary);
    min-height: 200px;
    opacity: 0;
    transform: translateY(-20px);
    transition: opacity 250ms, transform 250ms;
    border-radius: 0 0 8px 8px;
    z-index: 100;

    &.${MODIFIER_IS_OPEN} {
      opacity: 1;
      transform: translateY(0px);
    }

    .${contentWrapper} {
      padding-top: 20px;
      padding-left: 15px;
    }
  }
  .${profileLink} {
    display: flex;
    align-items: center;
  }
  .${hoveredLink} {
    color: var(--podium-cds-color-text-hover);
  }
  .${interactiveProfileElement} {
    color: var(--podium-cds-color-text-primary);
    &:hover {
      color: var(--podium-cds-color-text-hover);
    }
  }
`;

export const StyledNav = styled.nav`
  .${desktopList} {
    float: right;
    align-items: center;
    display: flex;
    padding-bottom: 0px;
    padding-right: 8px;

    .${iconBtnClass} {
      background: transparent;
      margin-left: 10px;

      &::before {
        border: none;
      }
    }

    .${desktopLinkClass} {
      position: relative;
      display: flex;
      align-items: center;
    }

    .${verticalLine} {
      border-right: 1px solid;
      height: 12px;
      margin: 12px;
    }
  }
  .${profileImageClass} {
    border-radius: 24px;
    width: 24px;
    height: 24px;
    display: inline-block;
    margin-left: 12px;
  }
`;
